import { IRecommendedWorkouts, IUpNextItemType, IUserWorkoutDetail } from '@ifit/gateway-wolf-dashboard-service';
import RowHeading from '../row-heading';
import CardSkeleton from '@ifit/mp-card-skeleton';
import { useUserType } from '../../state-management/selectors/use-user-type';
import { useRecommendedWorkouts } from '../../state-management/server-state/use-recommended-workouts';
import { useUserWorkoutDetails } from '../../state-management/server-state/use-user-workout-details';
import { useUpNextForYouItems } from '../../state-management/server-state/use-up-next-for-you-items';
import RecommendedWorkoutItem from './recommended-workout-item';
import { Text } from './text';
import { useMatrixCommercial } from '../../hooks/use-matrix-commercial';
import './index.scss';

const skeletonCards = Array(10).fill(0);

export default function RecommendedWorkoutsRow(): JSX.Element {
  const isMatrixCommerical = useMatrixCommercial();
  const recommendedWorkoutsQuery = useRecommendedWorkouts(false);
  const { data, isFetching, error, isLoading, isSuccess } = recommendedWorkoutsQuery;

  const workoutIds = data?.map((workout) => workout.id);
  const userWorkoutDetailsQuery = useUserWorkoutDetails(workoutIds);

  const zippedData: IRecommendedWorkoutsAndDetails[] = data?.map((workout) => {
    return {
      workout,
      userWorkoutDetail: userWorkoutDetailsQuery.data?.find((detail) => detail.workoutId === workout.id),
    };
  });

  const isAnonymous = useUserType() === 'anonymous';
  const upNextForYouQuery = useUpNextForYouItems(false);
  const scheduledAndJoinedWorkoutTypes = [
    IUpNextItemType.ContinueSeriesWorkout,
    IUpNextItemType.ScheduledWorkout,
    IUpNextItemType.LiveScheduledWorkout,
    IUpNextItemType.ContinueChallengeWorkout,
  ];
  const countScheduledAndJoined = upNextForYouQuery.data?.filter((workout) =>
    scheduledAndJoinedWorkoutTypes.includes(workout.type)
  ).length;
  const showRow = countScheduledAndJoined === 0 || countScheduledAndJoined >= 10;

  const noValidData = !data || data.length === 0;
  const errorWithNoCachedData = error && noValidData;
  const successWithNoData = noValidData && isSuccess;
  const hideRow = isAnonymous || errorWithNoCachedData || successWithNoData || !showRow || isMatrixCommerical;

  if (hideRow) {
    return null;
  }

  let content: JSX.Element[];

  if (isLoading) {
    content = skeletonCards.map((_, index) => <CardSkeleton key={index} className="custom" />);
  } else {
    content = zippedData.map((item) => <RecommendedWorkoutItem key={item.workout.id} item={item} />);
  }

  return (
    <div className="row-recommended-workouts">
      <RowHeading title={Text.title} fetching={isFetching} />
      <div className="cards" style={{ ['--cards-per-row' as any]: content.length }}>
        {content}
      </div>
    </div>
  );
}
export interface IRecommendedWorkoutsAndDetails {
  workout: IRecommendedWorkouts;
  userWorkoutDetail: IUserWorkoutDetail;
}
